import React from "react";
import styled from "styled-components";

import { themeColors } from "js/react/sharedStyles";
import { ThumbnailGrid } from "./ThumbnailGrid";

const SearchPreview = styled.div`
  background: white;
  padding: 20px 30px 20px;
  margin: 0px 0px 20px;
  overflow: hidden;
`;
const SearchPreviewTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #111;
  `;
const SearchPreviewHeader = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 1fr auto auto;
  gap: 10px;
  margin-bottom: 24px;

  p {
    font-size: 13px;
    color: ${themeColors.ui_blue};
    text-transform: uppercase;
    font-weight: bolder;
    &:hover {
      cursor: pointer;
    }
  }
`;

export function SlideSearchPreview({ thumbnail, items, title = "", onSelected, onSelectViewAll, showThemeThumbnails, onToggleUserTheme, hideUseCurrentThemeSwitch, showUserTheme, firstItem }) {
    return (firstItem || items.length > 0) ? (
        <SearchPreview>
            <SearchPreviewHeader>
                <SearchPreviewTitle>{title}</SearchPreviewTitle>
                {onSelectViewAll && <p onClick={onSelectViewAll}>View All Results</p>}
            </SearchPreviewHeader>
            <ThumbnailGrid
                forcedColumnCount={4}
                columns={3}
                colGap={30}
                rowGap={20}
                items={items}
                thumbnailClass={thumbnail}
                onItemDoubleClick={onSelected}
                onItemSelected={onSelected}
                firstItem={firstItem}
                showThemeThumbnails={showThemeThumbnails || showUserTheme}
            />
        </SearchPreview>
    ) : null;
}
